/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Use_Application_CommandsInputs */



/**
* | output |
* | --- |
* | "Use Application Commands" |
*
* @param {Leveling_Perm_Use_Application_CommandsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_use_application_commands = /** @type {((inputs?: Leveling_Perm_Use_Application_CommandsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Use_Application_CommandsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Использовать команды приложения")
	return /** @type {LocalizedString} */ ("Use Application Commands")
});